import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "crud-company flex flex-column" }
const _hoisted_2 = { class: "flex flex-align-center mb" }
const _hoisted_3 = {
  key: 0,
  class: "big icons8-user mr"
}
const _hoisted_4 = {
  key: 1,
  class: "big icons8-waste mr"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  key: 1,
  class: "mb"
}
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "crud-company__field" }
const _hoisted_9 = { class: "crud-company__label" }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = { class: "crud-company__field" }
const _hoisted_12 = { class: "crud-company__label" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = {
  key: 2,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 3,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 4,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.action !== _ctx.companyActions.Inactivate)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "icons8-delete close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.action === _ctx.companyActions.Create || _ctx.action === _ctx.companyActions.Update)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : (_ctx.action === _ctx.companyActions.Delete)
          ? (_openBlock(), _createElementBlock("i", _hoisted_4))
          : _createCommentVNode("", true),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.getTitleText)), 1)
    ]),
    (_ctx.getDescriptionText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.getDescriptionText)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.currentUser.roleName === _ctx.userRoles.SuperAdmin && _ctx.company)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("COMPANIES.ROW_LABELS.COMPANY_NAME")), 1),
              _withDirectives(_createElementVNode("input", {
                class: "crud-company__input",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.company.name]
              ]),
              (_ctx.errorMessage("CompanyName"))
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.errorMessage("CompanyName")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("COMPANIES.ROW_LABELS.CUSTOMER_NR")), 1),
              _withDirectives(_createElementVNode("input", {
                class: "crud-company__input",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.customerNr) = $event)),
                disabled: _ctx.action !== _ctx.companyActions.Create
              }, null, 8, _hoisted_13), [
                [_vModelText, _ctx.company.customerNr]
              ]),
              (_ctx.errorMessage("CustomerNr"))
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.errorMessage("CustomerNr")), 1))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.action === _ctx.companyActions.Inactivate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "crud-company__secondary",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 9, _hoisted_16),
          _createElementVNode("button", {
            class: _normalizeClass(["text-button ml-2", { "is-loading": _ctx.isLoading }]),
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 11, _hoisted_17)
        ]))
      : (_ctx.action === _ctx.companyActions.Activate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "crud-company__secondary",
              type: "button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 9, _hoisted_19),
            _createElementVNode("button", {
              class: _normalizeClass(["text-button ml-2", { "is-loading": _ctx.isLoading }]),
              type: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 11, _hoisted_20)
          ]))
        : (_ctx.action === _ctx.companyActions.Delete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "crud-company__secondary",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
                disabled: _ctx.isLoading
              }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 9, _hoisted_22),
              _createElementVNode("button", {
                class: _normalizeClass(["text-button ml-2", { "is-loading": _ctx.isLoading }]),
                type: "button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
                disabled: _ctx.isLoading
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 1),
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "icons8-waste" }, null, -1))
              ], 10, _hoisted_23)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 5,
              class: _normalizeClass(["crud-company__primary flex-self-end", { "is-loading": _ctx.isLoading }]),
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 11, _hoisted_24))
  ]))
}